import React from 'react';
interface PhoneImageProps {
  src: string;
  alt: string;
  className?: string;
}
export function PhoneImage({
  src,
  alt,
  className = ''
}: PhoneImageProps) {
  return <div className={`relative w-full max-w-[300px] aspect-[9/19] bg-gray-900 dark:bg-black rounded-[3rem] shadow-2xl overflow-hidden border-[8px] border-gray-900 dark:border-black mx-auto transition-colors duration-300 ${className}`} data-id="element-145" data-mp="aetr40pgrz04">
      {/* Notch */}
      <div className="absolute top-0 inset-x-0 h-7 flex justify-center z-20 pointer-events-none" data-id="element-146" data-mp="3iudh8quu91ay">
        <div className="w-28 h-7 bg-gray-900 dark:bg-black rounded-b-3xl transition-colors duration-300" data-id="element-147" data-mp="3nsewf0p58gh5" />
      </div>
      <img src={src} alt={alt} className="w-full h-full object-cover" data-id="element-148" data-mp="3sovkxw098wur" />
    </div>;
}